import type { useProposalStudio } from './useProposalStudio'
import { ProposalStudioEditorColumn } from './ProposalStudioEditorColumn'
import { ProposalStudioPreviewColumn } from './ProposalStudioPreviewColumn'

type Studio = ReturnType<typeof useProposalStudio>

export function ProposalStudioVisualView({ s }: { s: Studio }) {
  return (
    <div className="flex flex-1 min-h-0 w-full">
      <ProposalStudioEditorColumn s={s} />
      <ProposalStudioPreviewColumn s={s} />
    </div>
  )
}
